module.exports = __webpack_public_path__ + "static/media/open_book.3c7fdeb3.png";